import React from 'react'
import { createCssClass } from '../../helpers/common';

interface Props {
  name: string;
  label: string;
  value?: string | number | null;
  selected?: string | number | null;
  disabled?: boolean | (() => boolean);

  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const isSelected = (value?: string | number | null, selected?: string | number | null) => {
  if (!selected) return null;
  return value === selected ? 'selected' : null;
}

const isDisabled = (disabled?: boolean | (() => boolean)) => {
  if (!disabled) return null;
  if (typeof disabled === 'function') return disabled() ? 'disabled' : null;
  return disabled ? 'disabled' : null;
}

const ButtonInput: React.FC<Props> = ({ name, className, label, value, selected, disabled, onClick, ...rest }) => {
  return (
    <button
      className={createCssClass(['button-input', className, `${name}-${value}`, isSelected(value, selected), isDisabled(disabled)])}
      onClick={(e) => {
        e.preventDefault();
        if (isDisabled(disabled)) return;
        if (!onClick) return;
        onClick(e);
      }}
      {...rest}
    >
      {label}
    </button>
  )
}
export default ButtonInput;